// Quem está na mesa, consultado de tempos em tempos.
//
// Quem espera ser liberado consulta rápido (pra entrar assim que o anfitrião
// tocar em Liberar) e o anfitrião também (pra ver quem chegou). Os demais só
// atualizam a lista de rostos da comanda, sem pressa.
import { useCallback, useEffect, useRef, useState } from "react";

import * as api from "./api";

const ESPERANDO_MS = 3000;
const ANFITRIAO_MS = 5000;
const NORMAL_MS = 15000;

export function useParticipantes({ token, quem, ritmo, onResposta }) {
  const [dados, setDados] = useState(null);
  const onRespostaRef = useRef(onResposta);
  onRespostaRef.current = onResposta;

  const pronto = !!(token && quem);

  const recarregar = useCallback(async () => {
    if (!pronto) return;
    const r = await api.verParticipantes(token, quem);
    if (r.ok) setDados(r.dados);
    onRespostaRef.current?.(r);
  }, [token, pronto, quem]);

  useEffect(() => {
    if (!pronto) return undefined;
    recarregar();
    const ms = ritmo === "esperando" ? ESPERANDO_MS : ritmo === "anfitriao" ? ANFITRIAO_MS : NORMAL_MS;
    const id = setInterval(recarregar, ms);
    return () => clearInterval(id);
  }, [pronto, ritmo, recarregar]);

  const decidir = useCallback(async (alvoId, aprovar) => {
    const r = await api.decidirEntrada(token, quem, alvoId, aprovar);
    if (r.ok) setDados(r.dados);
    return r;
  }, [token, quem]);

  const pedirDeNovo = useCallback(async () => {
    const r = await api.pedirEntradaDeNovo(token, quem);
    if (r.ok) setDados(r.dados);
    onRespostaRef.current?.(r);
    return r;
  }, [token, quem]);

  return { dados, setDados, recarregar, decidir, pedirDeNovo };
}
